/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptInvoice200,
  AddInvoiceWeekReportRequest,
  AddWeekReport200,
  ApproveInvoice200,
  CancelInvoice200,
  CloseInvoice200,
  CreateInvoice200,
  CreateInvoiceRequest,
  DeleteInvoice200,
  GetInvoice200,
  GetInvoiceHistory200,
  GetInvoicePdf200,
  Invoice,
  InvoiceWeekReport,
  MarkOverdue200,
  PagedResponseInvoice,
  RejectInvoice200,
  RejectInvoiceRequest,
  RemoveWeekReport200,
  SearchInvoicesParams,
  SendInvoice200,
  UpdateInvoice200,
  UpdateInvoiceRequest
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List invoices for the caller's organisation
 */
export const listInvoices = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<Invoice[]>(
      {url: `/api/v1/invoices`, method: 'GET', signal
    },
      );
    }
  



export const getListInvoicesQueryKey = () => {
    return [
    `/api/v1/invoices`
    ] as const;
    }

    
export const getListInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoicesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoices>>> = ({ signal }) => listInvoices(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoices>>>
export type ListInvoicesQueryError = unknown


export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvoices>>,
          TError,
          Awaited<ReturnType<typeof listInvoices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvoices>>,
          TError,
          Awaited<ReturnType<typeof listInvoices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List invoices for the caller's organisation
 */

export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInvoicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a draft invoice from a set of APPROVED, not-yet-invoiced week reports
 */
export const createInvoice = (
    createInvoiceRequest: CreateInvoiceRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateInvoice200>(
      {url: `/api/v1/invoices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createInvoiceRequest, signal
    },
      );
    }
  


export const getCreateInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoice>>, TError,{data: CreateInvoiceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createInvoice>>, TError,{data: CreateInvoiceRequest}, TContext> => {

const mutationKey = ['createInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvoice>>, {data: CreateInvoiceRequest}> = (props) => {
          const {data} = props ?? {};

          return  createInvoice(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof createInvoice>>>
    export type CreateInvoiceMutationBody = CreateInvoiceRequest
    export type CreateInvoiceMutationError = unknown

    /**
 * @summary Create a draft invoice from a set of APPROVED, not-yet-invoiced week reports
 */
export const useCreateInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoice>>, TError,{data: CreateInvoiceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInvoice>>,
        TError,
        {data: CreateInvoiceRequest},
        TContext
      > => {

      const mutationOptions = getCreateInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List the week reports billed on this invoice
 */
export const listInvoiceWeekReports = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<InvoiceWeekReport[]>(
      {url: `/api/v1/invoices/${id}/week-reports`, method: 'GET', signal
    },
      );
    }
  



export const getListInvoiceWeekReportsQueryKey = (id?: string,) => {
    return [
    `/api/v1/invoices/${id}/week-reports`
    ] as const;
    }

    
export const getListInvoiceWeekReportsQueryOptions = <TData = Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoiceWeekReportsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoiceWeekReports>>> = ({ signal }) => listInvoiceWeekReports(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInvoiceWeekReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoiceWeekReports>>>
export type ListInvoiceWeekReportsQueryError = unknown


export function useListInvoiceWeekReports<TData = Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvoiceWeekReports>>,
          TError,
          Awaited<ReturnType<typeof listInvoiceWeekReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvoiceWeekReports<TData = Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvoiceWeekReports>>,
          TError,
          Awaited<ReturnType<typeof listInvoiceWeekReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvoiceWeekReports<TData = Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the week reports billed on this invoice
 */

export function useListInvoiceWeekReports<TData = Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoiceWeekReports>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInvoiceWeekReportsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Add another APPROVED week report to a draft invoice
 */
export const addWeekReport = (
    id: string,
    addInvoiceWeekReportRequest: AddInvoiceWeekReportRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddWeekReport200>(
      {url: `/api/v1/invoices/${id}/week-reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addInvoiceWeekReportRequest, signal
    },
      );
    }
  


export const getAddWeekReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWeekReport>>, TError,{id: string;data: AddInvoiceWeekReportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addWeekReport>>, TError,{id: string;data: AddInvoiceWeekReportRequest}, TContext> => {

const mutationKey = ['addWeekReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addWeekReport>>, {id: string;data: AddInvoiceWeekReportRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addWeekReport(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddWeekReportMutationResult = NonNullable<Awaited<ReturnType<typeof addWeekReport>>>
    export type AddWeekReportMutationBody = AddInvoiceWeekReportRequest
    export type AddWeekReportMutationError = unknown

    /**
 * @summary Add another APPROVED week report to a draft invoice
 */
export const useAddWeekReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWeekReport>>, TError,{id: string;data: AddInvoiceWeekReportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addWeekReport>>,
        TError,
        {id: string;data: AddInvoiceWeekReportRequest},
        TContext
      > => {

      const mutationOptions = getAddWeekReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Send the invoice to the client — partner only; creates the client's copy (one-shot)
 */
export const sendInvoice = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<SendInvoice200>(
      {url: `/api/v1/invoices/${id}/send`, method: 'POST', signal
    },
      );
    }
  


export const getSendInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInvoice>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendInvoice>>, TError,{id: string}, TContext> => {

const mutationKey = ['sendInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInvoice>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sendInvoice(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof sendInvoice>>>
    
    export type SendInvoiceMutationError = unknown

    /**
 * @summary Send the invoice to the client — partner only; creates the client's copy (one-shot)
 */
export const useSendInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInvoice>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendInvoice>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSendInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Reject a sent invoice — client only
 */
export const rejectInvoice = (
    id: string,
    rejectInvoiceRequest: RejectInvoiceRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<RejectInvoice200>(
      {url: `/api/v1/invoices/${id}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectInvoiceRequest, signal
    },
      );
    }
  


export const getRejectInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectInvoice>>, TError,{id: string;data: RejectInvoiceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectInvoice>>, TError,{id: string;data: RejectInvoiceRequest}, TContext> => {

const mutationKey = ['rejectInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectInvoice>>, {id: string;data: RejectInvoiceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectInvoice(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof rejectInvoice>>>
    export type RejectInvoiceMutationBody = RejectInvoiceRequest
    export type RejectInvoiceMutationError = unknown

    /**
 * @summary Reject a sent invoice — client only
 */
export const useRejectInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectInvoice>>, TError,{id: string;data: RejectInvoiceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectInvoice>>,
        TError,
        {id: string;data: RejectInvoiceRequest},
        TContext
      > => {

      const mutationOptions = getRejectInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Manually mark an unpaid invoice past its due date as overdue (own copy only)
 */
export const markOverdue = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<MarkOverdue200>(
      {url: `/api/v1/invoices/${id}/mark-overdue`, method: 'POST', signal
    },
      );
    }
  


export const getMarkOverdueMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markOverdue>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markOverdue>>, TError,{id: string}, TContext> => {

const mutationKey = ['markOverdue'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markOverdue>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  markOverdue(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkOverdueMutationResult = NonNullable<Awaited<ReturnType<typeof markOverdue>>>
    
    export type MarkOverdueMutationError = unknown

    /**
 * @summary Manually mark an unpaid invoice past its due date as overdue (own copy only)
 */
export const useMarkOverdue = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markOverdue>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markOverdue>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getMarkOverdueMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Archive a fully PAID invoice (own copy only)
 */
export const closeInvoice = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CloseInvoice200>(
      {url: `/api/v1/invoices/${id}/close`, method: 'POST', signal
    },
      );
    }
  


export const getCloseInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeInvoice>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof closeInvoice>>, TError,{id: string}, TContext> => {

const mutationKey = ['closeInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeInvoice>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  closeInvoice(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CloseInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof closeInvoice>>>
    
    export type CloseInvoiceMutationError = unknown

    /**
 * @summary Archive a fully PAID invoice (own copy only)
 */
export const useCloseInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeInvoice>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeInvoice>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCloseInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Cancel an invoice (own copy only, any non-terminal status)
 */
export const cancelInvoice = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CancelInvoice200>(
      {url: `/api/v1/invoices/${id}/cancel`, method: 'POST', signal
    },
      );
    }
  


export const getCancelInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelInvoice>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelInvoice>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelInvoice>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelInvoice(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof cancelInvoice>>>
    
    export type CancelInvoiceMutationError = unknown

    /**
 * @summary Cancel an invoice (own copy only, any non-terminal status)
 */
export const useCancelInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelInvoice>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelInvoice>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCancelInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Approve a draft invoice — own copy only, internal check before sending
 */
export const approveInvoice = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ApproveInvoice200>(
      {url: `/api/v1/invoices/${id}/approve`, method: 'POST', signal
    },
      );
    }
  


export const getApproveInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveInvoice>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveInvoice>>, TError,{id: string}, TContext> => {

const mutationKey = ['approveInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveInvoice>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  approveInvoice(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof approveInvoice>>>
    
    export type ApproveInvoiceMutationError = unknown

    /**
 * @summary Approve a draft invoice — own copy only, internal check before sending
 */
export const useApproveInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveInvoice>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveInvoice>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getApproveInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Accept a sent invoice — client only
 */
export const acceptInvoice = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AcceptInvoice200>(
      {url: `/api/v1/invoices/${id}/accept`, method: 'POST', signal
    },
      );
    }
  


export const getAcceptInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvoice>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvoice>>, TError,{id: string}, TContext> => {

const mutationKey = ['acceptInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvoice>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  acceptInvoice(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvoice>>>
    
    export type AcceptInvoiceMutationError = unknown

    /**
 * @summary Accept a sent invoice — client only
 */
export const useAcceptInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvoice>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvoice>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcceptInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single invoice
 */
export const getInvoice = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetInvoice200>(
      {url: `/api/v1/invoices/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetInvoiceQueryKey = (id?: string,) => {
    return [
    `/api/v1/invoices/${id}`
    ] as const;
    }

    
export const getGetInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getInvoice>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoice>>> = ({ signal }) => getInvoice(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoice>>>
export type GetInvoiceQueryError = unknown


export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoice>>,
          TError,
          Awaited<ReturnType<typeof getInvoice>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoice>>,
          TError,
          Awaited<ReturnType<typeof getInvoice>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single invoice
 */

export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoiceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a draft invoice — only while DRAFT; frees its week reports for invoicing again
 */
export const deleteInvoice = (
    id: string,
 ) => {
      
      
      return apiClient<DeleteInvoice200>(
      {url: `/api/v1/invoices/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoice>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvoice>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvoice>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteInvoice(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvoice>>>
    
    export type DeleteInvoiceMutationError = unknown

    /**
 * @summary Delete a draft invoice — only while DRAFT; frees its week reports for invoicing again
 */
export const useDeleteInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoice>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvoice>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update an invoice's dates/tax rate — only while DRAFT
 */
export const updateInvoice = (
    id: string,
    updateInvoiceRequest: UpdateInvoiceRequest,
 ) => {
      
      
      return apiClient<UpdateInvoice200>(
      {url: `/api/v1/invoices/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateInvoiceRequest
    },
      );
    }
  


export const getUpdateInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,{id: string;data: UpdateInvoiceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,{id: string;data: UpdateInvoiceRequest}, TContext> => {

const mutationKey = ['updateInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInvoice>>, {id: string;data: UpdateInvoiceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInvoice(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof updateInvoice>>>
    export type UpdateInvoiceMutationBody = UpdateInvoiceRequest
    export type UpdateInvoiceMutationError = unknown

    /**
 * @summary Update an invoice's dates/tax rate — only while DRAFT
 */
export const useUpdateInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,{id: string;data: UpdateInvoiceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInvoice>>,
        TError,
        {id: string;data: UpdateInvoiceRequest},
        TContext
      > => {

      const mutationOptions = getUpdateInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Generate a basic PDF preview of the invoice
 */
export const getInvoicePdf = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetInvoicePdf200>(
      {url: `/api/v1/invoices/${id}/pdf`, method: 'GET', signal
    },
      );
    }
  



export const getGetInvoicePdfQueryKey = (id?: string,) => {
    return [
    `/api/v1/invoices/${id}/pdf`
    ] as const;
    }

    
export const getGetInvoicePdfQueryOptions = <TData = Awaited<ReturnType<typeof getInvoicePdf>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePdf>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicePdfQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicePdf>>> = ({ signal }) => getInvoicePdf(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoicePdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicePdfQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicePdf>>>
export type GetInvoicePdfQueryError = unknown


export function useGetInvoicePdf<TData = Awaited<ReturnType<typeof getInvoicePdf>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePdf<TData = Awaited<ReturnType<typeof getInvoicePdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePdf<TData = Awaited<ReturnType<typeof getInvoicePdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePdf>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Generate a basic PDF preview of the invoice
 */

export function useGetInvoicePdf<TData = Awaited<ReturnType<typeof getInvoicePdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePdf>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicePdfQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary AUD-01/AUD-02: header change history for this invoice copy (not included-week-report changes)
 */
export const getInvoiceHistory = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetInvoiceHistory200>(
      {url: `/api/v1/invoices/${id}/history`, method: 'GET', signal
    },
      );
    }
  



export const getGetInvoiceHistoryQueryKey = (id?: string,) => {
    return [
    `/api/v1/invoices/${id}/history`
    ] as const;
    }

    
export const getGetInvoiceHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceHistory>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceHistoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceHistory>>> = ({ signal }) => getInvoiceHistory(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoiceHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceHistory>>>
export type GetInvoiceHistoryQueryError = unknown


export function useGetInvoiceHistory<TData = Awaited<ReturnType<typeof getInvoiceHistory>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoiceHistory>>,
          TError,
          Awaited<ReturnType<typeof getInvoiceHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoiceHistory<TData = Awaited<ReturnType<typeof getInvoiceHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoiceHistory>>,
          TError,
          Awaited<ReturnType<typeof getInvoiceHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoiceHistory<TData = Awaited<ReturnType<typeof getInvoiceHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary AUD-01/AUD-02: header change history for this invoice copy (not included-week-report changes)
 */

export function useGetInvoiceHistory<TData = Awaited<ReturnType<typeof getInvoiceHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoiceHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Paginated, filterable invoice list for the main Invoices list page
 */
export const searchInvoices = (
    params?: SearchInvoicesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponseInvoice>(
      {url: `/api/v1/invoices/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchInvoicesQueryKey = (params?: SearchInvoicesParams,) => {
    return [
    `/api/v1/invoices/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof searchInvoices>>, TError = unknown>(params?: SearchInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchInvoices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchInvoicesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchInvoices>>> = ({ signal }) => searchInvoices(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof searchInvoices>>>
export type SearchInvoicesQueryError = unknown


export function useSearchInvoices<TData = Awaited<ReturnType<typeof searchInvoices>>, TError = unknown>(
 params: undefined |  SearchInvoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchInvoices>>,
          TError,
          Awaited<ReturnType<typeof searchInvoices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchInvoices<TData = Awaited<ReturnType<typeof searchInvoices>>, TError = unknown>(
 params?: SearchInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchInvoices>>,
          TError,
          Awaited<ReturnType<typeof searchInvoices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchInvoices<TData = Awaited<ReturnType<typeof searchInvoices>>, TError = unknown>(
 params?: SearchInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchInvoices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable invoice list for the main Invoices list page
 */

export function useSearchInvoices<TData = Awaited<ReturnType<typeof searchInvoices>>, TError = unknown>(
 params?: SearchInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchInvoices>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Remove a week report from a draft invoice
 */
export const removeWeekReport = (
    id: string,
    weekReportId: string,
 ) => {
      
      
      return apiClient<RemoveWeekReport200>(
      {url: `/api/v1/invoices/${id}/week-reports/${weekReportId}`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveWeekReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeWeekReport>>, TError,{id: string;weekReportId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeWeekReport>>, TError,{id: string;weekReportId: string}, TContext> => {

const mutationKey = ['removeWeekReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeWeekReport>>, {id: string;weekReportId: string}> = (props) => {
          const {id,weekReportId} = props ?? {};

          return  removeWeekReport(id,weekReportId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveWeekReportMutationResult = NonNullable<Awaited<ReturnType<typeof removeWeekReport>>>
    
    export type RemoveWeekReportMutationError = unknown

    /**
 * @summary Remove a week report from a draft invoice
 */
export const useRemoveWeekReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeWeekReport>>, TError,{id: string;weekReportId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeWeekReport>>,
        TError,
        {id: string;weekReportId: string},
        TContext
      > => {

      const mutationOptions = getRemoveWeekReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    